import React from 'react';
import PropTypes from 'prop-types';
import MyDayRecipeCollectionCard from './my_day_recipe_collection_card';
import MyDayPlaceholderCard from '../shared_programmes/my_day_placeholder_card';
import {
  useGetDistilledMealsByParentQuery,
  useGetSharedBoardQuery,
  useGetDistilledSharedMealsByParentQuery,
  useGetSmorgBoardQuery,
} from '../../app/smorgAppSyncGraphQLApi';
import { SHARED_BOARDS_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';

const MyDayRecipeCollectionItem = ({
  boardID,
  title,
  firstMealID,
  onClickBoard,
  isFavourite,
  isSharedBoard,
}) => {
  const { data: smorgBoard, isLoading: isSmorgBoardLoading } =
    useGetSmorgBoardQuery(boardID, { skip: !boardID || isSharedBoard });

  const { data: sharedBoard } = useGetSharedBoardQuery(boardID, {
    skip: !boardID || !isSharedBoard,
    refetchOnMountOrArgChange: SHARED_BOARDS_REFRESH_INTERVAL_SECONDS,
  });

  const { data: distilledMeals } = useGetDistilledMealsByParentQuery(boardID, {
    skip: !boardID || isSharedBoard,
  });

  const { data: distilledSharedMeals } =
    useGetDistilledSharedMealsByParentQuery(boardID, {
      skip: !boardID || !isSharedBoard,
    });

  let boardCoverImageUrl = (smorgBoard || sharedBoard)?.coverImageUrl;
  if (!boardCoverImageUrl && firstMealID) {
    boardCoverImageUrl = ((
      (distilledMeals || {})[firstMealID] ||
      (distilledSharedMeals || {})[firstMealID]
    )?.recipes || [])[0]?.imageUrl;
  }

  return !isSmorgBoardLoading ? (
    <MyDayRecipeCollectionCard
      boardID={boardID}
      title={title}
      coverImageUrl={boardCoverImageUrl}
      onClickBoard={onClickBoard}
      isFavourite={isFavourite}
    />
  ) : (
    <MyDayPlaceholderCard />
  );
};

MyDayRecipeCollectionItem.propTypes = {
  boardID: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  firstMealID: PropTypes.string,
  onClickBoard: PropTypes.func.isRequired,
  isFavourite: PropTypes.bool.isRequired,
  isSharedBoard: PropTypes.bool.isRequired,
};

MyDayRecipeCollectionItem.defaultProps = {
  firstMealID: null,
};

export default MyDayRecipeCollectionItem;
